import React from "react";
import { useNavigate } from "react-router-dom";
import { PackageOpen, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const SmallQuantityEnquiry = () => {
  const navigate = useNavigate();
  const { cart, extras, eventInfo, selectedPackageId } = useApp();
  const hasContext = cart.length > 0 || extras.length > 0 || !!selectedPackageId || !!eventInfo.guests;

  return (
    <section
      data-testid="small-qty-section"
      className="mt-14 overflow-hidden rounded-3xl border border-accent/50 bg-accent/10"
    >
      <div className="flex flex-col items-start gap-5 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div className="flex items-start gap-4">
          <div className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-primary/10">
            <PackageOpen className="h-6 w-6 text-primary" aria-hidden />
          </div>
          <div>
            <h2 className="font-serif-display text-lg font-semibold text-secondary md:text-lg">
              Need a smaller quantity?
            </h2>
            <p className="mt-1 max-w-xl text-sm text-muted-foreground">
              For smaller quantities, please enquire with us.
              {hasContext && " Your current selection and guest count will be included in the enquiry."}
            </p>
          </div>
        </div>
        <button
          data-testid="small-qty-enquire-btn"
          onClick={() => navigate("/request-quote", { state: { smallQuantity: true } })}
          className="btn-primary w-full shrink-0 sm:w-auto"
        >
          Enquire Now <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
};
